($ => {

    "use strict";
    console.log('app.js');

})(jQuery);